import React from "react";
import { useNavigate } from "react-router-dom"; // useNavigate'i import edin
import {
  Users,
  Target,
  Award,
  Globe,
  BookOpen,
  Heart,
  TrendingUp,
  CheckCircle,
  Lightbulb,
  Shield,
  Clock,
  Star,
  X,
} from "lucide-react";

function About() {
  const navigate = useNavigate(); // navigate fonksiyonunu oluşturun

  const values = [
    {
      icon: <Heart className="w-6 h-6" />,
      title: "Öğrenci Odaklılık",
      description: "Her kararımızın merkezinde öğrenci başarısı var",
    },
    {
      icon: <Lightbulb className="w-6 h-6" />,
      title: "Yenilikçilik",
      description: "Eğitim teknolojilerinde sınırları zorluyoruz",
    },
    {
      icon: <Shield className="w-6 h-6" />,
      title: "Güvenilirlik",
      description: "Veri güvenliği ve gizlilik en yüksek önceliğimiz",
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: "İşbirliği",
      description: "Birlikte daha iyisini başarıyoruz",
    },
  ];

  // Geri gitme fonksiyonu
  const handleGoBack = () => {
    navigate(-1); // Bir önceki sayfaya git
    // Veya belirli bir sayfaya yönlendirmek isterseniz:
    // navigate("/"); // Ana sayfaya git
  };

  return (
    <div className="min-h-screen px-4 py-2">
      {/* X butonu - sol üstte */}
      <div className="flex justify-end mb-4">
        {" "}
        {/* justify-start ile sola hizalayın */}
        <button
          onClick={handleGoBack}
          className="p-3 rounded-full bg-red-500 text-white hover:bg-red-700  transition-all duration-200 shadow-lg hover:shadow-xl"
          aria-label="Geri dön"
        >
          <X className="w-6 h-6" />
        </button>
      </div>

      <div className="max-w-7xl mx-auto mt-4">
        {/* Hero Bölümü */}
        <div className="text-center mb-16">
          <div
            className="inline-flex items-center gap-2 bg-purple-500
           text-white font-normal px-4 py-2 rounded-full mb-6"
          >
            <BookOpen className="w-5 h-5 text-yellow-300" />
            <span className="font-semibold">Eğitimde Devrim</span>
          </div>

          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
            Eğitimi <span className="text-purple-600">Dönüştürüyoruz</span>
          </h1>

          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            2026'den beri öğretmen ve öğrencilerin buluştuğu dijital platform
            olarak, eğitim deneyimini yeniden tanımlıyoruz. Her gün binlerce
            sınıfı bir araya getiriyoruz.
          </p>
        </div>

        {/* Misyon & Vizyon */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          <div className="bg-yellow-500 rounded-2xl p-8 shadow-xl border border-emerald-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-blue-100 p-3 rounded-full">
                <Target className="w-8 h-8 text-blue-600" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">Misyonumuz</h2>
            </div>
            <p className="text-white font-normal text-lg leading-relaxed mb-6">
              Her bireyin potansiyelini ortaya çıkaracak eğitim fırsatlarına
              erişimini sağlamak. Teknolojiyi kullanarak öğrenmeyi daha
              etkileşimli, erişilebilir ve keyifli hale getiriyoruz.
            </p>
            <ul className="space-y-3">
              {[
                "Erişilebilir eğitim",
                "Kişiselleştirilmiş öğrenme",
                "Sürekli yenilik",
                "Topluluk odaklı",
              ].map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-blue-600" />
                  <span className="text-white font-normal">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-purple-500 rounded-2xl p-8 shadow-xl border border-blue-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-blue-100 p-3 rounded-full">
                <Globe className="w-8 h-8 text-blue-600" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">Vizyonumuz</h2>
            </div>
            <p className="text-white font-normal text-lg leading-relaxed mb-6">
              2030 yılına kadar Türkiye'nin en etkili eğitim platformu olmak ve
              küresel çapta milyonlarca öğrenciye ulaşmak. Eğitimde dijital
              dönüşümün öncüsü olarak, geleceğin öğrenme deneyimini
              şekillendiriyoruz.
            </p>
            <div className="bg-blue-50 p-4 rounded-xl">
              <div className="flex items-center gap-3">
                <TrendingUp className="w-6 h-6 text-blue-600" />
                <div>
                  <h4 className="font-bold text-gray-900">Büyüme Hedefimiz</h4>
                  <p className="text-sm text-gray-600">
                    Önümüzdeki 3 yılda 1 milyon aktif kullanıcı
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Değerlerimiz */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Değerlerimiz
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Başarımızın arkasında yatan temel prensipler ve inandıklarımız
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-gray-100 rounded-2xl p-6 shadow-lg border border-gray-100 
                hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div
                  className="bg-purple-500 text-white w-14 h-14 
                rounded-xl flex items-center justify-center mb-4"
                >
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {value.title}
                </h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Sonuç */}
        <div className="text-center max-w-3xl mx-auto">
          <h3 className="text-3xl font-bold text-gray-900 mb-6">
            Eğitimin geleceğini birlikte şekillendirelim
          </h3>
          <p className="text-gray-600 text-lg mb-8">
            Her gün daha fazla öğretmen ve öğrenciye ulaşmanın heyecanıyla
            çalışmaya devam ediyoruz. Siz de bu dönüşümün bir parçası olmak
            ister misiniz?
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
